module.exports = __webpack_public_path__ + "static/whiteshirt-94c40e4cc5905717e6fdc4ba897cc8d4.png";